<template>
  <div>
    <StatisticProjectReportsBlankMainTable
      class="f14"
      v-if="left && right"
      :left="left"
      :right="right"
      :project-id="projectId"
    />
    <div v-if="confirmPage" class="mb-5">
      <div class="d-flex align-center mb-5">
        {{ localStorage.translations.pages.finance['period-table']['general_note'] + ':' }}
        <BaseInput
          type="switch"
          autofocus
          v-model="showGeneralNote"
          class="ml-4"
          @input="switchNote"
        />
      </div>
      <BaseInput
        v-if="showGeneralNote"
        v-model="general_note"
        :placeholder="localStorage.translations.pages.finance['period-table']['general_note']"
        type="textarea"
        @input="set_general_note"
      />
    </div>
    <div class="ba" :class="$vuetify.breakpoint.smAndDown ? 'f12' : 'f14'">
      <div class="report_helper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import StatisticProjectReportsBlankMainTable from '../StatisticProjectReportsBlankMainTable'
import {mapGetters, mapMutations} from 'vuex'
import BaseInput from 'components/base/BaseInput.vue'

export default {
  name: 'StatisticProjectReportsBlankTable',
  components: { BaseInput, StatisticProjectReportsBlankMainTable },
  props: {
    left: Array,
    right: Array,
    projectId: {
      type: [String, Number],
      default: null,
    },
    confirmPage: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showGeneralNote: false,
    general_note: '',
  }),
  computed: {
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote']),
  },
  created() {
    this.showGeneralNote = this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.showReportGeneralNote || ''
    this.general_note = this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.reportGeneralNote || ''
  },
  methods: {
    ...mapMutations('workClientProjectsClientReports', ['setWorkClientProjectsClientReportsGeneralNote']),
    switchNote(data) {
      this.setWorkClientProjectsClientReportsGeneralNote({
        report_id: this.$route.params.report_id,
        showReportGeneralNote: data,
        reportGeneralNote: this.general_note
      })
    },
    set_general_note() {
      this.setWorkClientProjectsClientReportsGeneralNote({
        report_id: this.$route.params.report_id,
        showReportGeneralNote: this.showGeneralNote,
        reportGeneralNote: this.general_note
      })
    },
  },
}
</script>

<style scoped lang="scss">
.report_helper {
  :deep() .cell:not(.v-input) {
    position: relative;
    min-height: 30px;
    min-width: 32px;
    width: 100%;
    padding: 4px 6px;
    border: 1px solid #ebebeb !important;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .v-text-field {
    margin: 0 !important;
    padding: 0 !important;
  }

  :deep() .v-text-field input {
    padding: 4px 0 !important;
  }

  :deep() .v-text-field .v-input__control {
    border-radius: 0 !important;
    height: 100% !important;
  }

  :deep() .v-input .v-input__slot:not(.v-textarea) fieldset {
    color: #ebebeb !important;
  }

  :deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
    min-height: 30px !important;
  }

  :deep()
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    padding: 0 4px !important;
  }
}

.b {
  &a {
    border: 1px solid #ebebeb;
  }

  &t {
    border-top: 1px solid #ebebeb;
  }

  &r {
    border-right: 1px solid #ebebeb;
  }

  &b {
    border-bottom: 1px solid #ebebeb;
  }

  &l {
    border-left: 1px solid #ebebeb;
  }
}
</style>
